package pages

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun NotFoundPage(onNavigate: (String) -> Unit) {
    Section(attrs = {
        style {
            property("padding", "6rem 1.5rem")
            textAlign("center")
            property("min-height", "calc(100vh - 300px)")
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
    }) {
        Div(attrs = {
            style {
                maxWidth(32.cssRem)
                property("margin", "0 auto")
            }
        }) {
            // Illustration
            Img(src = "/static/images/no_reward.webp", alt = "Page not found", attrs = {
                style {
                    maxWidth(16.cssRem)
                    property("margin", "0 auto 1.5rem")
                    display(DisplayStyle.Block)
                    borderRadius(1.cssRem)
                }
            })

            // Heading
            H1(attrs = {
                style {
                    fontSize(1.5.cssRem)
                    fontWeight(700)
                    property("color", "var(--on-surface)")
                    marginBottom(0.75.cssRem)
                }
            }) { Text("Looks like this page wandered off") }

            // Description
            P(attrs = {
                style {
                    fontSize(1.cssRem)
                    property("color", "var(--on-surface-variant)")
                    property("line-height", "1.6")
                    marginBottom(2.cssRem)
                }
            }) { Text("The page you're looking for doesn't exist or may have been moved. But hey, there's plenty more to explore.") }

            // Primary CTA
            A(attrs = {
                classes("not-found-page__button")
                attr("href", "/")
                style {
                    display(DisplayStyle.InlineBlock)
                    property("padding", "0.75rem 2rem")
                    property("background-color", "var(--primary)")
                    property("color", "var(--on-primary)")
                    borderRadius(0.5.cssRem)
                    fontWeight(600)
                    textDecoration("none")
                    property("transition", "opacity 0.2s")
                    cursor("pointer")
                }
                onClick { e ->
                    e.preventDefault()
                    onNavigate("/")
                }
            }) { Text("Take me home") }

            // Divider
            Div(attrs = {
                style {
                    property("margin", "2.5rem 0")
                    height(1.px)
                    property("background-color", "var(--outline-variant)")
                }
            })

            // Help label
            P(attrs = {
                style {
                    fontSize(0.8.cssRem)
                    property("color", "var(--on-surface-variant)")
                    property("text-transform", "uppercase")
                    letterSpacing(0.05.em)
                    fontWeight(600)
                    marginBottom(1.cssRem)
                }
            }) { Text("You might be looking for") }

            // Links grid
            Div(attrs = {
                style {
                    display(DisplayStyle.Grid)
                    property("grid-template-columns", "repeat(auto-fit, minmax(12rem, 1fr))")
                    gap(1.cssRem)
                }
            }) {
                NotFoundLinkCard(
                    name = "Astro Navya",
                    description = "AI-powered Vedic astrology",
                    url = "https://www.astronavya.com"
                )
            }
        }
    }
}

@Composable
private fun NotFoundLinkCard(name: String, description: String, url: String) {
    A(attrs = {
        classes("not-found-page__link-card")
        attr("href", url)
        attr("target", "_blank")
        attr("rel", "noopener noreferrer")
        style {
            display(DisplayStyle.Block)
            textDecoration("none")
            borderRadius(0.75.cssRem)
            padding(1.25.cssRem)
            property("border", "1px solid var(--outline-variant)")
            property("background-color", "var(--surface-container)")
            property("transition", "border-color 0.2s, transform 0.2s")
            property("color", "inherit")
        }
    }) {
        P(attrs = {
            style {
                fontSize(1.cssRem)
                fontWeight(700)
                property("color", "var(--primary)")
                marginBottom(0.25.cssRem)
            }
        }) { Text(name) }
        P(attrs = {
            style {
                fontSize(0.85.cssRem)
                property("color", "var(--on-surface-variant)")
                property("line-height", "1.4")
            }
        }) { Text(description) }
    }
}
